import {Gender} from './gender.model';
import * as UserDocumentTypeModel from './document-type.model';
import {BankAccount} from './bank.model';

export enum InvitationDocumentType {
    VOTER_CARD = 'VOTER_CARD',
    PASSPORT = 'PASSPORT',
    LPG_BILL = 'LPG_BILL',
    MTNL_BSNL_BILL = 'MTNL_BSNL_BILL',
    ELECTRICITY_BILL = 'ELECTRICITY_BILL',
    PHOTOGRAPH = 'PHOTOGRAPH',
    PAN = 'PAN',
    DRIVING_LICENSE = 'DRIVING_LICENSE',
    AADHAAR = 'AADHAAR'
}

export class DocumentTypeMapper {
    public static map(type: InvitationDocumentType): UserDocumentTypeModel.DocumentType {
        switch (type) {
            case InvitationDocumentType.VOTER_CARD:
                return UserDocumentTypeModel.DocumentType.Voter;

            case InvitationDocumentType.PASSPORT:
                return UserDocumentTypeModel.DocumentType.Passport;

            case InvitationDocumentType.LPG_BILL:
                return UserDocumentTypeModel.DocumentType.LpgBill;

            case InvitationDocumentType.MTNL_BSNL_BILL:
                return UserDocumentTypeModel.DocumentType.TelephoneBill;

            case InvitationDocumentType.ELECTRICITY_BILL:
                return UserDocumentTypeModel.DocumentType.ElectricityBill;

            case InvitationDocumentType.PHOTOGRAPH:
                return UserDocumentTypeModel.DocumentType.Photo;

            case InvitationDocumentType.PAN:
                return UserDocumentTypeModel.DocumentType.Pan;

            case InvitationDocumentType.DRIVING_LICENSE:
                return UserDocumentTypeModel.DocumentType.Driving;

            case InvitationDocumentType.AADHAAR:
                return UserDocumentTypeModel.DocumentType.Aadhaar;
        }
    }
}

export class AddressProofMapper {
    public static map(type: UserDocumentTypeModel.DocumentType): UserDocumentTypeModel.DocumentType {
        switch (type) {
            case UserDocumentTypeModel.DocumentType.Voter:
                return UserDocumentTypeModel.DocumentType.VoterId;
            case UserDocumentTypeModel.DocumentType.Driving:
                return UserDocumentTypeModel.DocumentType.DrivingLicense;
            default:
                return type;
        }
    }
}

export class GenderMapper {
    public static map(gender: string): Gender {
        switch (gender) {
            case 'MALE' || Gender.Male:
                return Gender.Male;
            case 'FEMALE' || Gender.Female:
                return Gender.Female;
            case 'OTHER' || Gender.Other:
                return Gender.Other;
        }
    }
}

export enum ProofType {
    BUSINESS = 'BUSINESS',
    ADDRESS = 'ADDRESS',
    IDENTITY = 'IDENTITY'
}

export class Document {
    public fileId: string;
    public file: File;
    public documentType: InvitationDocumentType;
    public proofType: ProofType;
    public proofNumber: string;

    constructor(documentType: InvitationDocumentType, proofType: ProofType, fileId: any, proofNumber: string, file: any) {
        this.documentType = documentType;
        this.proofType = proofType;
        this.fileId = fileId;
        this.proofNumber = proofNumber;
        this.file = file;
    }
}

export class Address {
    public addressLine: string;
    public city: string;
    public state: string;
    public pinCode: string;
    public addressProofType: InvitationDocumentType;
    public addressProofNumber: string;

    constructor();
    constructor(city: string, state: string, pinCode: string, addressLine: string, proofType: InvitationDocumentType, proofNumber: string);
    constructor(city?: string, state?: string, pinCode?: string, addressLine?: string, proofType?: InvitationDocumentType, proofNumber?: string) {
        this.city = city;
        this.state = state;
        this.pinCode = pinCode;
        this.addressLine = addressLine;
        this.addressProofType = proofType;
        this.addressProofNumber = proofNumber;
    }
}

export class Invitee {
    public pan: string;
    public name: string;
    public gender: Gender;
    public emailId: string;
    public extras: any;
    public phoneNumber: string;
    public address: Address;
    public bankAccount: BankAccount;
    public documents: Document[];

    constructor(pan: string, name: string, gender: Gender, emailId: string, extras: any,
                phoneNumber: string, address: Address, bankAccount: BankAccount, documents: Document[]) {
        this.pan = pan;
        this.name = name;
        this.gender = gender;
        this.emailId = emailId;
        this.extras = extras;
        this.phoneNumber = phoneNumber;
        this.address = address;
        this.bankAccount = bankAccount;
        this.documents = documents;
    }
}
